import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from '../../../redux/modalSlice';

const SOURCE_LABELS = {
  express_loan: 'Express Loan Denied',
  cash_out_refinance: 'Cash Out Refinance Denied',
  collection_refinance: 'Collection Refinance Denied',
};

export default function DSDeniedModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);

  const handleClose = () => {
    dispatch(setModal({ is_active: false }));
  };

  if (!(modal.is_active && modal.type === 'ds_denied_modal')) {
    return null;
  }

  const title = SOURCE_LABELS[modal.options?.source] ?? 'Application Denied';

  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card modal-card-confirmation column is-5">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            {title}
          </p>
          <button className="delete" aria-label="close" onClick={handleClose}></button>
        </header>
        <section
          className="modal-card-body pt-1 pb-1"
          style={{ minHeight: '100px', overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              <div className="notification is-danger is-light">
                <p className="is-size-6">
                  Unfortunately, the system is denying the application; this is a system determination. The system does not give us a reason why, but you are welcome to reapply again in 30 days.
                </p>
              </div>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button
              type="button"
              className="button is-small has-background-grey has-text-white"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
}
